import moment from 'moment-timezone';

const getHumanReadableFormattedTimes = ({ valueFrom, valueTo, timezone }) => {
  const timeFrom = moment(valueFrom);
  const timeTo = moment(valueTo);

  if (timezone) {
    timeFrom.tz(timezone);
    timeTo.tz(timezone);
  }

  return `${timeFrom.format('HH:mm')} - ${timeTo.format('HH:mm')}`;
};

export default getHumanReadableFormattedTimes;
